(function () {
  'use strict';

  var LIMITS = {
    '1003': 4,
    '2003': 4,
  };

  var LANG = (document.documentElement.lang || 'fr').substring(0, 2);

  var MSGS = {
    fr: function (max) {
      return 'Maximum ' + max + ' unités de ce produit par commande.';
    },
    en: function (max) {
      return 'Maximum ' + max + ' units of this product per order.';
    },
  };

  function getMsg(max) {
    return (MSGS[LANG] || MSGS.fr)(max);
  }

  function showAlert(msg) {
    var existing = document.getElementById('sku-limit-alert');
    if (existing) existing.remove();

    var el = document.createElement('div');
    el.id = 'sku-limit-alert';
    el.setAttribute('role', 'alert');
    el.style.cssText =
      'position:fixed;top:0;left:0;right:0;z-index:99999;padding:14px 20px;' +
      'background:#c0392b;color:#fff;text-align:center;font-size:14px;font-weight:600;' +
      'font-family:inherit;box-shadow:0 2px 12px rgba(0,0,0,0.2);animation:skuSlideIn .3s ease';
    el.textContent = msg;

    var close = document.createElement('button');
    close.textContent = '\u2715';
    close.style.cssText =
      'position:absolute;right:12px;top:50%;transform:translateY(-50%);background:none;' +
      'border:none;color:#fff;font-size:18px;cursor:pointer;padding:4px 8px';
    close.onclick = function () { el.remove(); };
    el.appendChild(close);

    document.body.appendChild(el);
    setTimeout(function () { if (el.parentNode) el.remove(); }, 6000);
  }

  var originalFetch = window.fetch;
  var isFixing = false;

  window.fetch = function (url, options) {
    var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');

    if (isFixing) return originalFetch.apply(this, arguments);

    if (urlStr.indexOf('/cart/add') !== -1 && options && options.body) {
      return handleCartAdd(url, options);
    }

    if (urlStr.indexOf('/cart/change') !== -1 && options && options.body) {
      return handleCartChange(url, options);
    }

    return originalFetch.apply(this, arguments);
  };

  function handleCartAdd(url, options) {
    var body = parseBody(options.body);
    var sectionIds = [];
    if (body && body.sections) {
      sectionIds = typeof body.sections === 'string' ? body.sections.split(',') : body.sections;
    }

    return originalFetch(url, options)
      .then(function (response) {
        return response.clone().json().then(function (addData) {
          if (addData.status) return response;

          return originalFetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var violations = findViolations(cart);
              if (violations.length === 0) return response;

              isFixing = true;
              return fixViolations(violations)
                .then(function () {
                  showAlert(getMsg(violations[0].max));

                  if (sectionIds.length > 0) {
                    var sectionsUrl = (body && body.sections_url) || window.location.pathname;
                    return originalFetch(sectionsUrl + '?sections=' + sectionIds.join(','))
                      .then(function (r) { return r.json(); })
                      .then(function (sections) {
                        addData.sections = sections;
                        isFixing = false;
                        return new Response(JSON.stringify(addData), {
                          status: 200,
                          headers: { 'Content-Type': 'application/json' },
                        });
                      });
                  }

                  isFixing = false;
                  refreshCartUI();
                  return new Response(JSON.stringify(addData), {
                    status: 200,
                    headers: { 'Content-Type': 'application/json' },
                  });
                })
                .catch(function () {
                  isFixing = false;
                  return response;
                });
            });
        }).catch(function () { return response; });
      });
  }

  function handleCartChange(url, options) {
    var body = parseBody(options.body);
    if (!body) return originalFetch(url, options);

    var newQty = parseInt(body.quantity, 10);
    if (isNaN(newQty) || newQty <= 0) return originalFetch(url, options);

    return originalFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lineIndex = null;

        if (body.line) {
          lineIndex = parseInt(body.line, 10) - 1;
        } else if (body.id) {
          for (var i = 0; i < cart.items.length; i++) {
            if (String(cart.items[i].key) === String(body.id) ||
                String(cart.items[i].variant_id) === String(body.id)) {
              lineIndex = i;
              break;
            }
          }
        }

        if (lineIndex === null || lineIndex < 0 || lineIndex >= cart.items.length) {
          return originalFetch(url, options);
        }

        var item = cart.items[lineIndex];
        var sku = item.sku || '';

        if (LIMITS[sku] && newQty > LIMITS[sku]) {
          showAlert(getMsg(LIMITS[sku]));
          var fixedBody = JSON.parse(JSON.stringify(body));
          fixedBody.quantity = LIMITS[sku];
          return originalFetch(url, {
            method: options.method || 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(fixedBody),
          });
        }

        return originalFetch(url, options);
      });
  }

  function findViolations(cart) {
    var violations = [];
    cart.items.forEach(function (item, index) {
      if (LIMITS[item.sku] && item.quantity > LIMITS[item.sku]) {
        violations.push({
          line: index + 1,
          sku: item.sku,
          max: LIMITS[item.sku],
        });
      }
    });
    return violations;
  }

  function fixViolations(violations) {
    var chain = Promise.resolve();
    violations.forEach(function (v) {
      chain = chain.then(function () {
        return originalFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: v.line, quantity: v.max }),
        });
      });
    });
    return chain;
  }

  function refreshCartUI() {
    var drawer = document.querySelector('cart-drawer-items');
    if (drawer && typeof drawer.onCartUpdate === 'function') {
      drawer.onCartUpdate();
      return;
    }
    var cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.onCartUpdate === 'function') {
      cartItems.onCartUpdate();
    }
  }

  function parseBody(body) {
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch (e) { return null; }
    }
    if (body instanceof FormData) {
      var obj = {};
      body.forEach(function (val, key) { obj[key] = val; });
      return obj;
    }
    return null;
  }

  /* Checkout button guard — disable checkout if limits are violated */
  function guardCheckout() {
    originalFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var violations = findViolations(cart);
        var btns = document.querySelectorAll('[name="checkout"], #CartDrawer-Checkout, #checkout, a[href="/checkout"], button[name="checkout"]');
        btns.forEach(function (btn) {
          if (violations.length > 0) {
            btn.setAttribute('disabled', 'disabled');
            btn.style.pointerEvents = 'none';
            btn.style.opacity = '0.5';
          } else {
            btn.removeAttribute('disabled');
            btn.style.pointerEvents = '';
            btn.style.opacity = '';
          }
        });
      })
      .catch(function () {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(guardCheckout, 200);
    });
  }

  var style = document.createElement('style');
  style.textContent = '@keyframes skuSlideIn{from{transform:translateY(-100%)}to{transform:translateY(0)}}';
  document.head.appendChild(style);
})();
